module.exports = __webpack_public_path__ + "static/media/info-blue.a3c96876.svg";